var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed flex tw-items-center justify-center top-0 left-0 w-screen h-screen"},[_vm._v(" LOADING ")])}
var staticRenderFns = []

export { render, staticRenderFns }